import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { RevealLines } from "@/components/shared/RevealText";

export default function PageHero({ eyebrow, title, subtitle, chapter, testId }) {
    return (
        <section className="relative border-b border-ink/10 bg-white py-24 md:py-32" data-testid={testId || "page-hero"}>
            <div className="pointer-events-none absolute inset-x-0 top-0 h-[400px] bg-[radial-gradient(700px_300px_at_30%_0%,rgba(244,63,94,0.08),transparent)]" />
            <div className="container-x relative">
                <div className="mb-6 flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.24em] text-slate-500">
                    <Link to="/" className="hover:text-pink">Home</Link>
                    <ChevronRight className="h-3 w-3" />
                    <span>{eyebrow}</span>
                </div>
                <div className="grid grid-cols-1 items-end gap-8 md:grid-cols-12">
                    <div className="md:col-span-8">
                        {chapter && (
                            <div className="eyebrow mb-4">{chapter}</div>
                        )}
                        <h1 className="h-display font-display text-[46px] font-black leading-[0.95] text-ink md:text-[92px]">
                            <RevealLines lines={[title]} />
                        </h1>
                    </div>
                    {subtitle && (
                        <motion.p
                            initial={{ opacity: 0, y: 12 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.7, delay: 0.4 }}
                            className="md:col-span-4 max-w-md text-[15px] leading-relaxed text-slate-600 md:text-[16px]"
                        >
                            {subtitle}
                        </motion.p>
                    )}
                </div>
            </div>
        </section>
    );
}
